import React, { Component } from "react";

export default class NoPageFound extends Component {
  render() {
    return <div> No Page Found</div>;
  }
}
